export const STRING = 'STRING';
export const NUMBER = 'NUMBER';
export const DATE = 'DATE';


// WEBPACK FOOTER //
// ./src/shared/constants/InvoiceFiltersTypes.js